



import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CREATE_Call_DISPOSITION_URl, DELETE_Call_DISPOSITION_URl, GET_Call_DISPOSITION_URl, UPDATE_Call_DISPOSITION_URl, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllCallDisposition = createAsyncThunk('GetCallDisposition', async (_, { rejectWithValue }) => {

    try {

        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_Call_DISPOSITION_URl, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllCallDispositionSlice = createSlice({
    name: 'Call Disposition',
    initialState: {
        CallDisposition: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllCallDisposition.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllCallDisposition.fulfilled, (state, action) => {
                state.CallDisposition = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllCallDisposition.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const GetSingleCallDispositionSlice = createSlice({
    name: 'Single CallDisposition ',
    initialState: {
        CallDisposition: ''
    },
    reducers: {
        setCallDispositionItem: (state, action) => {
            state.CallDisposition = action.payload;
        }
    }
});

export const CreateCallDisposition = createAsyncThunk('CreateCall', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_Call_DISPOSITION_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', ' Call Disposition Created successfully.')
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateCallDisposition = createAsyncThunk('updatemenu', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_Call_DISPOSITION_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Call Disposition updated successfully.')

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteCallDisposition = createAsyncThunk('deletMenu', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_Call_DISPOSITION_URl, { CallDispositionMasterID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Call Disposition Deleted successfully.')

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const {setCallDispositionItem} = GetSingleCallDispositionSlice.actions
export {
    GetAllCallDispositionSlice,
    GetSingleCallDispositionSlice
};
